



























import Vue from 'vue';
import { pickerMaxWidth } from '@/constants';
import { DateFormat } from '@/mixins';
import { ExtendMixins } from '@/services';

interface Data {
  date: string;
  pickerVisible: boolean;
  pickerMaxWidth: string;
}

export default ExtendMixins(
  DateFormat,
).extend({
  name: 'DatePicker',
  props: {
    dateModel: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    allowedDates: {
      type: Function,
      default() {
        return true;
      },
    },
  },
  data(): Data {
    return {
      // @ts-ignore
      date: this.parseModel(),
      pickerVisible: false,
      pickerMaxWidth,
    };
  },
  watch: {
    dateModel() {
      this.date = this.parseModel();
    },
  },
  methods: {
    saveDate(): void {
      (this.$refs.dateDialog as any).save(this.date);
      this.$emit('updateDate', this.date);
      this.$emit('datePickerClose');
    },
    showPicker(): void {
      this.pickerVisible = true;
      this.$emit('datePickerOpen');
    },
    cancelDatePicker(): void {
      this.pickerVisible = false;
      this.date = this.parseModel();
      this.$emit('datePickerClose');
    },
    parseModel(): string {
      // @ts-ignore
      return this.parseDate(this.dateModel)
        // @ts-ignore
        ? this.parseDate(this.dateModel)
        : null;
    },
  },
});
